import {useState} from "react";
import '../styles/fundadores.css';
import Petalos from '../components/petalos'
import abuelos from '../assets/fundadores/abuelos1.jpg'
import abuelosactual from '../assets/fundadores/abuelosactual.jpg'
import mamamagotiti from '../assets/fundadores/mamamagotitipassed.jpg'
import mamamagoentrevista from '../assets/fundadores/mamamagoentrevista.jpg'



function Fundadores(){
    const [showInfo, setShowInfo] = useState(false);
    const [showInfo2, setShowInfo2] = useState(false);

    return(
        <div>
            <Petalos />
            <div className="mensaje-fundadores">
                <h2>Inicios</h2>
                <p>Al rededor de los años 80 Margarita Sánchez Limón y Raul Flores Cortes, 2 jovenes enamorados se encontraban buscabando una forma de salir adelante,
                    aunque al tener ambos la fortuna de venir de una familia trabajadora dedicada a oficios como la panaderia y carniceria respectivamente, ellos querian 
                    algo propio, algo con lo que se sintieran identificados y que por supuesto disfrutaran, fue entonces que obtaron por incursionar en un 
                    negocio aún sin pies ni cabeza del cual ellos fueron pioneros en el municipio de Amozoc, la elaboración de artesanias, que para esos momentos se limitaba 
                    a juguetes y figuras pequeñas como animales.
                </p>
            </div>
            <div className="abuelos-inicios">
                <div className="foto-con-info">
                    <img src={abuelos} alt="Margarita y Raúl" />
                    <div
                        className="info-icon"
                        onClick={() => setShowInfo(!showInfo)}
                        title="Ver descripción"
                    >
                    !
                    </div>
                    {showInfo && (
                        <div className="info-text">
                        Margarita y Raúl en su boda en el año de 1969.
                        </div>
                    )}
                </div>
                <div className="foto-con-info">
                    <img src={abuelosactual} alt="Margarita y Raúl" />
                    <div
                        className="info-icon"
                        onClick={() => setShowInfo2(!showInfo2)}
                        title="Ver descripción"
                    >
                    !
                    </div>
                    {showInfo2 && (
                        <div className="info-text">
                        Margarita y Raúl en sus bodas de oro en el año 2019.
                        </div>
                    )}
                </div>
                
            </div>
            <div className="mensaje-fe">
                <h2>Bajo la guía de Dios</h2>
                <p>
                    México, país católico y con costumbres arraigadas a la fé como sus fiestas patronales o
                    las tradiciones de semana santa, hacen que los fieles de esta religión tengan bien 
                    inculcados estos valores. 
                </p>
                <p>
                    Esa misma fé motivo a Margarita a dar un paso mas alla en su negocio, vio en la inspiración 
                    de dar un buen testimonio la opción de agregar a sus artesanias la elaboracion de artículos religiosos.
                    Estos articulos empezaron siendo niños Dios, cristos y la especialidad nacimientos, al igual que los juguetes
                    estas primeras artesanias eran de barro o yeso, aunque eso si, hechas a mano y con una dedicación unica a cada
                    una de las creaciones que producian. 
                </p>
                <p>
                    Posteriormente fue agregando a su catálogo mas variedad, tanto de piezas como algunas basadas en santos, como de materiales, incluyendo 
                    madera y resina, todo esto para poder cubrir las necesidades que el negocio estaba alcanzando y poder satisfacer a los clientes.
                </p>
                <p>
                    Margarita siempre pensó que su negocio era el negocio de Dios, es decir se encomendaba, trabajaba y enseñaba a quien se lo permitiera un poco
                    de lo que es ser un buen católico, tal vez ahí esta la clave de el progreso que tuvo su "Jugeteria" y por el cual siempre estuvo agradecida.
                </p>

            </div>
            <div className="foto-mamamago-entrevista">
                    <img src={mamamagoentrevista} alt="Entrevista a Margarita" />
            </div>
            <div className="mensaje-legado">
                <h2>Memoria y legado</h2>
                <p>
                    La pandemia de Covid en el año 2019 fue una tragedia en todo el mundo, y de la misma forma tambien toco las puertas en la familia de Margarita y Raúl,
                    y fue precisamente a ella, quien junto a su hijo mas pequeño partieron de este mundo al llamado de Dios el día 11 de junio del 2020. 
                </p>
                <p>
                    Margarita mejor conocida como "doña Mago" paso a ser parte de lo que tanto proclamo acá en vida, se le recuerda por ser una gran persona, madre, hija, abuela y 
                    tambien por haber creado junto a su esposo un lugar que mas a allá de ser un trabajo, sería aquella tienda donde expondria sus valores y creencias.  
                </p>
                <p>
                    Hoy en día y con mas de 40 años de existencia "Jugueteria Mago" es el legado que tanto Margarita y Raúl lograron crear, enseñando a hijos y luego a nietos
                    que con trabajo duro, perseverancia y fé en Dios puedes salir adelante.
                </p>
            </div>
            <div className="foto-mamamago-titi">
                    <img src={mamamagotiti} alt="Margarita y Cristian" />
            </div>
            <div className="mensaje-salmo">
                    <h3 className="salmo">
                        “Tu divina providencia se extienda en cada momento para que nunca nos falte casa,vestido y sustento, y a la 
                        hora de la muerte tu sagrado sacramento.”
                    </h3>
                    {/* <h4 className="salmocap">
                        Salmo 50:14
                    </h4> */}
            </div>
            
        </div>
    )
}

export default Fundadores;